import { Gigya as gigya } from "integration/gigya";

export default gigya;